import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { NavItem, NavLink } from 'reactstrap';

const HeaderLink = props => (
  <NavItem>
    <NavLink tag={Link} to={props.to} onClick={props.onClick}>
      {props.title}
    </NavLink>
  </NavItem>
);

HeaderLink.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
};

export default HeaderLink;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLink.js